/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState } from 'react';
import { Observer } from 'mobx-react';
import { toJS } from 'mobx';
import { css } from '@emotion/core';
import { useLocation, Prompt } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Button } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { useRootStore } from '../../stores/BridgeProvider';
import Spinner from '../util/Spinner';
import DealMapperContainer from '../common/DealMapperContainer';
import DealMapTable from './DealMapTable';
import DealSearch from './columns/DealColumn/DealSearch';
import VoucherSearch from './columns/VoucherColumn/VoucherSearch';
import DealMapperDrawer from './DealMapperDrawer';
import DealMapperJoyride from '../joyrides/DealMapperJoyride';

const FlexStuff = css`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 5px;
  overflow-y: auto;
  flex-grow: 1;
  padding-bottom: 80px;
`;

const TablesContainer = css`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-bottom: 1rem;
`;

const TopContainer = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1900px;
  padding: 0px 50px;
  box-sizing: border-box;
  align-items: center;
  margin: 0.5rem 0rem;
`;

const SearchContainer = css`
  display: flex;
  flex-direction: row;
  flex: 1;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 8px;

  .fillButtons {
    padding: 0px 5px;
    flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
  }
`;

const PageContainer = css`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  min-width: 1000px;
  max-height: calc(100vh - 64px);
  @supports (-moz-appearance: none) {
    max-height: inherit;
  }
`;

const DealMapper = () => (
  <Observer
    render={() => {
      const { dealMapperStore } = useRootStore();
      return (
        <div css={PageContainer}>
          <Prompt
            when={dealMapperStore.isAnythingPending}
            message="You have unsaved changes, are you sure you want to leave?"
          />
          <div css={FlexStuff}>
            <div css={TablesContainer}>
              <div css={TopContainer}>
                <div css={SearchContainer}>
                  <DealSearch />
                  <div className="fillButtons">
                    <div style={{ width: '12rem', textAlign: 'right' }}>
                      <Button onClick={dealMapperStore.voucherDeals}>
                        Fill Vouchers{' '}
                        <ArrowForwardIcon style={{ marginLeft: '1rem' }} />
                      </Button>
                    </div>
                    <div style={{ width: '12rem' }}>
                      <Button
                        onClick={dealMapperStore.mapVouchers}
                        className="dmStep2"
                      >
                        <ArrowBackIcon style={{ marginRight: '1rem' }} /> Fill
                        Deals
                      </Button>
                    </div>
                  </div>
                  <VoucherSearch />
                </div>
              </div>
              <DealMapTable />
            </div>
          </div>
          <DealMapperDrawer />
        </div>
      );
    }}
  />
);

const Wrapper = () => {
  const { state } = useLocation();
  const { dataStore, dealMapperStore } = useRootStore();
  const [isLoading, setLoading] = useState(true);
  useEffect(() => {
    const initialize = async () => {
      const requests = [
        dataStore.retrieveContacts(),
        dataStore.retrieveAccounts(),
        dataStore.retrieveTransactionCategories(),
      ];
      await Promise.all(requests);
      setLoading(false);
    };
    initialize();
  }, []);

  useEffect(() => {
    return () => {
      dealMapperStore.clearState();
    };
  }, []);

  if (isLoading) return <Spinner />;
  return (
    <div>
      <DealMapperContainer
        dealIds={state && state.dealIds}
        voucherIds={state && state.voucherIds}
        invoiceDeal={state && state.invoiceDeal}
      >
        <DealMapperJoyride />
        <DealMapper />
      </DealMapperContainer>
    </div>
  );
};

export default Wrapper;
